<script>
  import EditView from '../base/EditView.vue'
  import FormInput from '../form/form-input.vue'
  import FormDataurl from '../form/form-dataurl.vue'

  export default {
    components: {
      EditView,
      FormInput,
      FormDataurl,
    },
  }
</script>
<template>
  <edit-view store="companyasset" list-route="CompanyAssetList" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="filename" class="col-12"></form-input>
    <form-dataurl :store="slotProps.store" prop-name="content" class="col-12"></form-dataurl>
  </edit-view>
</template>

